import { useState } from 'react';

import { ComponentPodcastGetInTouch, Enum_Podcastinteraction_Type, Maybe } from '@/graphql/generated/graphql';
import Button from '@/components/Button';
import { zodResolver } from '@hookform/resolvers/zod';
import { SubmitHandler, useForm } from 'react-hook-form';
import { z } from 'zod';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { createPodcastInteraction } from '@/services/podcast/podcast.service';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';

const schema = z.object({
  email: z.string().email({ message: 'Invalid email address' }),
  text: z.string().min(1, { message: 'Please enter a message' }),
});

export type FormInputs = z.infer<typeof schema>;

interface ExpandableCardProps {
  getInTouchSection?: Maybe<ComponentPodcastGetInTouch> | null;
  type: Enum_Podcastinteraction_Type;
}

const ExpandableCard = ({ getInTouchSection, type }: ExpandableCardProps) => {
  const { register, reset, handleSubmit } = useForm<FormInputs>({
    resolver: zodResolver(schema),
  });

  const [isSubmited, setIsSubmited] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);

  const onSubmit: SubmitHandler<FormInputs> = async (data) => {
    createPodcastInteraction({
      email: data.email,
      text: data.text,
      type: type,
      guests: getInTouchSection?.guests ? getInTouchSection?.guests?.data.map((guest) => guest.id!) || [] : [],
    });

    reset();
    toggleCard();
    setIsSubmited(true);
  };

  const toggleCard = () => {
    setIsExpanded(true);
    // setIsExpanded(!isExpanded);
  };

  return (
    <AnimatedFadeInComponent className="col-span-12 flex h-full flex-col items-center justify-center gap-sh-15 rounded-2xl bg-primary-600 p-sh-30  text-white">
      {isSubmited ? (
        <div>
          <h2 className="mb-4 text-sh-md font-bold">{getInTouchSection?.thanksTitle}</h2>
          <p className="mb-4 text-sh-sm">{getInTouchSection?.thanksDescription}</p>
        </div>
      ) : (
        <>
          {' '}
          <div className={`${!isExpanded ? 'block' : 'hidden'} text-center`}>
            <h2 className="mb-4 text-lg font-semibold">{getInTouchSection?.boxText}</h2>
            <Button
              theme="solid-white"
              onClick={() => {
                toggleCard();
              }}>
              {getInTouchSection?.buttonText}
            </Button>
          </div>
          <div className={isExpanded ? 'block' : 'hidden'}>
            <h2 className="mb-4 text-sh-md font-bold">{getInTouchSection?.titleModal}</h2>
            <p className="mb-4 text-sh-sm">{getInTouchSection?.descriptionModal}</p>
            <form onSubmit={handleSubmit(onSubmit)} className="mt-sh-30 flex flex-col items-start gap-4">
              <div className="w-1/2">
                <Label className=" text-left">
                  <p className="mb-2 text-sh-xs">{getInTouchSection?.emailPlaceholder}</p>
                </Label>
                <Input placeholder={getInTouchSection?.emailPlaceholder} type="email" {...register('email')} />
              </div>

              <div className="w-full">
                <Label className=" text-left">
                  <p className="mb-2 text-sh-xs">{getInTouchSection?.yourTextPlaceholder}</p>
                </Label>
                <Input
                  as="textarea"
                  placeholder={getInTouchSection?.yourTextPlaceholder}
                  type="text"
                  {...register('text')}
                />
              </div>

              <Button theme="solid-primary-600" type="submit">
                {getInTouchSection?.submitText}
              </Button>
            </form>
          </div>
        </>
      )}
    </AnimatedFadeInComponent>
  );
};

export default ExpandableCard;
